import React from "react";
import Carousel from "../Carousel/Carousel";
import colors from "../../theme/Theme";

const OtherProductsCarousel = ({ items }) => {
  if (!items.length) return null;
  const normalizedItems = items.map((item) => ({
    ...item,
    imageFit: item.imageFit || "contain",
    imageBg: item.imageBg || "#f5f6f8",
  }));

  return (
    <div className="mt-10 pb-4">
      <div className="mx-auto max-w-[1180px]">
        <h2 className="w-fit border-b-4 border-b-primary-green pb-3 text-2xl font-bold text-black md:text-4xl">
          Otros productos
        </h2>
        <Carousel
          items={normalizedItems}
          desktopRows={1}
          desktopColumns={4}
          mobileRows={2}
          mobileColumns={2}
          dotsColor={colors.greenPrimary}
          labelBgColor={colors.greenPrimary}
        />
      </div>
    </div>
  );
};

export default OtherProductsCarousel;
